/* eslint-disable max-depth */
import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useArtcleOne = (article_id: string): any => {
  const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useConfigcontext---------", context.useApiError);
  // Shared ref holding the response from the API
  const artcle = sharedRef(null, `useArtcleOne-${article_id}`);
  const artcleList = sharedRef(null, `useArtcleOne-${article_id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useArtcleOne-loading-${article_id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useArtcleOne-error-${article_id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const articleOneGet = async (params: CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.artcleOneGet(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        if (res.data) {
          const artcle1 = JSON.parse(JSON.stringify(res.data));
          if (artcle1) {
            const regex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/gi;
            artcle1.content = artcle1?.content.replace(regex, (match, href) => {
              const locale = context?.$cookies.get('vsf-locale');
              if (!href.startsWith('http://') && !href.startsWith('https://') && !href.startsWith('#') && locale) {
                const updatedHref = `${'/' + locale}${href}`;
                const updatedAnchorTag = match.replace(href, updatedHref);
                return updatedAnchorTag;
              } else {
                return match;
              }
            });
          }
          artcle.value = artcle1;
        } else {
          artcle.value = res.data;
        }
        error.value = null;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    articleOneGet: articleOneGet,
    artcle: computed(() => artcle.value),
    artcleList: computed(() => artcleList.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
